import React from 'react';
import { Center, HStack, Box, useTheme } from 'native-base';
import TopicReplyForm from './TopicReplyForm';
import { useAuthState } from '../../../../context/auth';
import { useEnvState } from '../../../../context/env';
import UserAvatar from './UserAvatar';
const CreateEditButton = ({
  isTypeTopic,
  edit,
  type,
  topic,
  reply,
  handlePost,
  startNewTopicButtonRef,
  showUserProfile,
  onCloseHandler
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const isEditMode = edit;
  const envState = useEnvState();
  const authState = useAuthState();
  const userAvatar = authState.auth_user_avatar;
  const handlePress = () => {
    showUserProfile({
      username: `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`,
      avatar_template: userAvatar
    });
  };
  const TopicButton = /*#__PURE__*/React.createElement(Box, {
    width: '100%',
    bg: {
      base: colors.createEditButton.container.bg,
      lg: 'none'
    },
    py: 3
  }, /*#__PURE__*/React.createElement(HStack, {
    bg: colors.createEditButton.bg,
    px: 4,
    py: 3,
    borderColor: colors.topic.createButton.border,
    borderTopWidth: {
      base: 1,
      lg: 0
    },
    borderBottomWidth: {
      base: 1,
      lg: 0
    }
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    onPress: handlePress,
    marginRight: 3,
    userAvatar: userAvatar,
    moderator: authState.moderator
  }), /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(TopicReplyForm, {
    handlePost: handlePost,
    forceTypeTopic: true,
    newTopicButton: true,
    type: type,
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    startNewTopicButtonRef: startNewTopicButtonRef,
    onCloseHandler: onCloseHandler
  }))));
  const ReplyButton = /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(TopicReplyForm, {
    handlePost: handlePost,
    newReplyButton: true,
    type: type,
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    onCloseHandler: onCloseHandler
  }));
  const EditButton = /*#__PURE__*/React.createElement(Box, {
    width: '100%'
  }, /*#__PURE__*/React.createElement(TopicReplyForm, {
    handlePost: handlePost,
    edit: true,
    editButton: true,
    type: type,
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    onCloseHandler: onCloseHandler
  }));
  if (!isEditMode) {
    if (isTypeTopic) {
      return TopicButton;
    }
    return ReplyButton;
  }
  return EditButton;
};
export default CreateEditButton;
//# sourceMappingURL=CreateEditButton.js.map